export function ImgAttachFile( { size = 16 }: { size?: number } ) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
        <path d="M13 15l2-2 4 4" />
        <circle cx="15" cy="13" r="1" />
    </svg>
  )
}